module.exports = __webpack_public_path__ + "static/img/logo.496e5a9f.png";